module.exports = __webpack_public_path__ + "img/Shaman-orc-m-70.2bec7629.gif";